/**
 * Lazy Sentry frontend init. No-op if REACT_APP_SENTRY_DSN_FRONTEND is missing.
 * Dynamically imports @sentry/react only when DSN is present, so unused
 * SDK does not ship in the production bundle.
 */
export async function initSentryFrontend() {
  const dsn = process.env.REACT_APP_SENTRY_DSN_FRONTEND;
  if (!dsn) return;
  try {
    const Sentry = await import("@sentry/react");
    Sentry.init({
      dsn,
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      environment: process.env.NODE_ENV || "production",
    });
    window.__sentry_loaded = true;
  } catch (e) {
    // Sentry SDK not installed yet — silent
  }
}
